module.exports = __webpack_public_path__ + "assets/41f871314fef25dbe8d31eed77012f34.jpg";